export default {
  apiUrl: "/api/carts_count",
  dataPath: "result.rows",
  paginationPath: "data",
  trackBy: "wine_id",
  detailRowComponentName: "carts-management-component",
  // customActionComponentName: "CartsManagementCustomActionComponent",
  onEachSide: 1,
  preloadList: [],
  sortOrder: [
    {
      field: "wine_id",
      sortField: "id",
      direction: "DESC"
    }
  ],
  paginationTemplate: {
    class: "",
    template: "총 {total}개 중의 {from} 부터 {to}"
  },
  fields: [
    {
      name: "wine_id",
      title: '<i style="white-space: nowrap">와인 아이디</i>',
      sortField: "wine_id",
      titleClass: "text-center",
      dataClass: "text-right"
    },
    {
      name: "wine_name",
      title: '<i style="white-space: nowrap">와인 이름</i>',
      sortField: "wine_name",
      titleClass: "text-center",
      dataClass: "text-right",
      callback: "nameField"
    },
    {
      name: "cart_count",
      title: '<i style="white-space: nowrap">카트에 담긴 카운트</i>',
      sortField: "cart_count",
      titleClass: "text-center",
      dataClass: "text-right"
    },
    {
      name: "order_count",
      title: '<i style="white-space: nowrap">구매된 카운트</i>',
      sortField: "order_count",
      titleClass: "text-center",
      dataClass: "text-right"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/spa/components/board/carts-management/Config.js